export default __webpack_public_path__ + "static/media/LITHIUM.06c534b1.svg";